<template>
  <div id="app">
    <v-app id="inspire" dark>
      <v-navigation-drawer
        :clipped="drawer.clipped"
        :fixed="drawer.fixed"
        :permanent="drawer.permanent"
        :mini-variant.sync="drawer.mini"
        v-model="drawer.open"
        app
      >
        <v-list-item>
          <v-list-item-avatar>
            <v-img :src="profileUrl" alt="avatar"></v-img>
          </v-list-item-avatar>
          <v-list-tile-content>
            <v-list-item-title>{{ user.firstName }} {{ user.lastName}}</v-list-item-title>
            <v-list-tile-sub-title class="caption teal--text">{{ user.role }}</v-list-tile-sub-title>
          </v-list-tile-content>

          <div class="ml-5">
            <v-btn icon @click.stop="drawer.mini = !drawer.mini">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </div>
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense shaped>
          <v-list-item-group v-model="item" color="teal darken-3">
            <v-list-item v-for="(item, i) in items" :key="i" :to="item.link">
              <v-list-item-icon>
                <v-icon color="black">{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <template v-slot:append>
          <div class="pa-3">
            <v-btn block outlined class="elevation-19 black--text" @click="logout">
              <v-row align="center" justify="center">
                <v-icon small class>mdi-logout</v-icon>
                <span class="ml-2" v-show="!drawer.mini">Logout</span>
              </v-row>
            </v-btn>
          </div>
        </template>
      </v-navigation-drawer>
      <div>
        <router-view></router-view>
      </div>
      <v-footer app :fixed="footer.fixed" :clipped-left="footer.clippedLeft">
        <span class="caption mx-3">
          &copy; 2018, GDGAddis - Made with
          <span style="color: #e25555; font-size: 15px">&#9829;</span> by CodeNight Team
        </span>
      </v-footer>
    </v-app>
  </div>
</template>


<script>
import { mapActions, mapState } from "vuex";
import { baseUrl } from "@/services/constants.js";

export default {
  data: () => ({
    // profileUrl: baseUrl + "auth/img/me",
    mini: true,
    item: { title: "Dashboard", icon: "mdi-home-city", link: "/dashboard" },
    items: [
      { title: "Dashboard", icon: "mdi-home-city", link: "/dashboard" },
      {
        title: "Users",
        icon: "mdi-account-group-outline",
        link: "/users-list"
      },
      { title: "My Account", icon: "mdi-account", link: "/myAccount" }
    ],
    drawer: {
      // sets the open status of the drawer
      open: true,
      // sets if the drawer is shown above (false) or below (true) the toolbar
      clipped: false,
      // sets if the drawer is CSS positioned as 'fixed'
      fixed: false,
      // sets if the drawer remains visible all the time (true) or not (false)
      permanent: true,
      // sets the drawer to the mini variant, showing only icons, of itself (true)
      // or showing the full drawer (false)
      mini: true
    },
    toolbar: {
      //
      fixed: true,
      // sets if the toolbar contents is leaving space for drawer (false) or not (true)
      clippedLeft: false
    },
    footer: {
      // sets the CSS position of the footer
      fixed: true,
      // sets if the footer is full width (true) or gives space to the drawer (false)
      clippedLeft: true
    }
  }),

  computed: {
    ...mapState("auth", ["user"]),
    profileUrl() {
      if (this.user.sex == "Male") {
        if (this.user.proffession == "Software Engineer") {
          return require("@/assets/images/SE/m.jpg");
        } else if (this.user.proffession == "Developer") {
          return require("@/assets/images/DV/m.png");
        } else return require("@/assets/images/ST/m.png");
      } else {
        if (this.user.proffession == "Software Engineer") {
          return require("@/assets/images/SE/f.jpg");
        } else if (this.user.proffession == "Developer") {
          return require("@/assets/images/DV/f.png");
        } else return require("@/assets/images/ST/f.png");
      }
    }
  },

  methods: {
    ...mapActions("auth", ["logout"]),
    // changes the drawer to permanent
    makeDrawerPermanent() {
      this.drawer.permanent = true;
      // set the clipped state of the drawer and toolbar
      this.drawer.clipped = false;
      this.toolbar.clippedLeft = false;
    },
    // toggles the drawer variant (mini/full)
    toggleMiniDrawer() {
      this.drawer.mini = !this.drawer.mini;
    },
    // toggles the drawer type (permanent vs temporary) or shows/hides the drawer
    toggleDrawer() {
      if (this.drawer.permanent) {
        this.drawer.permanent = !this.drawer.permanent;
        // set the clipped state of the drawer and toolbar
        this.drawer.clipped = true;
        this.toolbar.clippedLeft = true;
      } else {
        // normal drawer
        this.drawer.open = !this.drawer.open;
      }
    }
    // logout function
  }
};
</script>